"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStoragePlugin = void 0;
const hasLocalStorage = typeof localStorage !== "undefined";
const localStoragePlugin = (storageKey) => {
    const leadEvents = (lead) => ({
        onUpdate: () => {
            if (hasLocalStorage) {
                localStorage.setItem(storageKey, JSON.stringify(lead));
            }
        },
    });
    leadEvents.clearCache = () => {
        if (hasLocalStorage) {
            localStorage.removeItem(storageKey);
        }
    };
    leadEvents.onLoad = (initialState) => {
        if (initialState || !hasLocalStorage)
            return initialState;
        const val = localStorage.getItem(storageKey);
        if (!val)
            return;
        try {
            return JSON.parse(val);
        }
        catch (err) {
            localStorage.removeItem(storageKey);
            return;
        }
    };
    return leadEvents;
};
exports.localStoragePlugin = localStoragePlugin;
//# sourceMappingURL=local-storage.js.map